import { render, staticRenderFns } from "./sellFranchise.vue?vue&type=template&id=475f3fff"
import script from "./sellFranchise.vue?vue&type=script&lang=js"
export * from "./sellFranchise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports